import gql from 'graphql-tag';

export const LoginQuery = gql`
  mutation LoginUser($username: String!, $password: String!) {
    login(username: $username, password: $password) {
      success
      token
    }
  }
`;



// WEBPACK FOOTER //
// ./src/views/Login/Logingql.js